import { isProductionApi } from '@/util/helpers'
import { QUESTION_STATUS } from '@/constants/marketBackendEnums'

/** The tag page the home banner sends people to. */
export const MIDTERMS_TAG_SLUG = 'midterm'

/** Election day, midnight US Eastern (EST, after the November clock change). */
export const MIDTERMS_ELECTION_DATE = '2026-11-03T05:00:00Z'

/**
 * "Control of the US Senate after the 2026 elections". A production id: the
 * same number points at an unrelated market on staging.
 */
export const MIDTERMS_SENATE_MARKET_ID = 211467

/**
 * Only a build pointed at the production exchange renders the live market;
 * local, staging and PR previews serve this snapshot instead, so the banner
 * never quotes whatever market happens to own the id there.
 */
export const MIDTERMS_USE_MOCK = !isProductionApi()

/**
 * The production market's own shape: a mono custom market (one physical
 * outcome, the parties as long/short position labels, the price quoting the
 * long side — see docs/MARKET_UI_TYPES.md, Type A), so every environment
 * exercises the same code path production serves.
 */
export const MOCK_SENATE_MARKET = {
  id: MIDTERMS_SENATE_MARKET_ID,
  title: 'Control of the US Senate after the 2026 elections',
  slug: 'control-of-the-us-senate-after-the-2026-elections',
  status: QUESTION_STATUS.OPEN,
  markets_correlation: 'independent',
  outcomes_type: 'custom',
  outcomes: [
    {
      id: -1,
      title: 'Control of the US Senate after the 2026 elections',
      position_labels: 'custom',
      long_label: 'Republican Party',
      short_label: 'Democratic Party',
      price: { OOM: 0.5 },
    },
  ],
}
